import { Injectable } from '@angular/core';
import { WorkFlow } from './types';

@Injectable()
export class WorkFlowMessageService {
  private messageHandler: (callback: (e: WorkFlow.IMessage) => void) => (event: any) => void;
  private handler: (event: any) => void;
  constructor() {
    this.messageHandler = (callback: (e: WorkFlow.IMessage) => void) => {
      return (event: any) => {
        const message = event.data as WorkFlow.IMessage;
        if (message && typeof message === 'object') {
          message.sender = event.source;
        }
        if (typeof callback === 'function') {
          callback(message);
        }
      };
    };
  }
  /**
   * çå¬å·¥ä½æµæ¶æ¯
   * @param callback - åè°
   */
  public listen(callback: (e: WorkFlow.IMessage) => void) {
    this.handler = this.messageHandler(callback);
    window.addEventListener('message', this.handler);
  }
  public destroy() {
    if (this.handler) {
      window.removeEventListener('message', this.handler);
    }
  }
  /**
   * ç»å·¥ä½æµè¡¨ååéæ¶æ¯
   * @param message
   */
  public send(message: WorkFlow.IMessage): void {
    if (!message) {
      return;
    }
    let win: Window = window;
    if (message.target) {
      win = message.target as Window || window;
      delete message.target;
    }
    if (win) {
      win.postMessage(message, '*');
    }
  }
}
